class PrintCheckinController {
    /*@ngInject*/
    constructor($state, $stateParams, User, ShipmentService){
        this.ShipmentService = ShipmentService;
        this.$state = $state;
        this.$stateParams = $stateParams;
        this.User = User;
        this.isRouteAutoCheckin = false;
        this.model = {
            generateCheckinManifest: false,
            itemList: []
        }
    }

    $onInit() {
        const branchId = this.$stateParams.branchId;
        const routeId = this.$stateParams.scannedRouteId;
        const vaultDate = this.$stateParams.date;

        this.model.generateCheckinManifest = true;
        this.ShipmentService.getCheckinManifestData(branchId, routeId, vaultDate)
        .then((data) => {
            this.routeId = routeId;
            this.isRouteAutoCheckin = data.routeAutoCheckIn;
            this.deliveryDate = vaultDate;
            this.shipmentReportData = data;
            this.model.itemList = data.itemList;
            this.userData = this.User.getUser();
            this.messengerDetails = data.messengerDetail;
            if (this.isRouteAutoCheckin) {
                this.holdShipments = data.results.filter(ship => ship.holdFlag === true);
                this.nonHoldShipments = data.results.filter(ship => !ship.holdFlag);
            } else {
                this.holdShipments = [];
                this.nonHoldShipments = data.results;
            }
            setTimeout(() => {
                window.print();
            }, 1000)
        })
        .catch((err) => {
            console.log(err);
        })
        .finally(() => {
            this.loading = false;
            this.model.generateCheckinManifest = false;
        })
    }
}

export default PrintCheckinController;


// WEBPACK FOOTER //
// ./client/app/components/checkin/print/print_checkin.controller.js